import React from "react";
import IconAddmoney from "../../assets/images/IconAddmoney";
import IconAEPS from '../../assets/images/IconAEPS';
import IconBillRecharge from "../../assets/images/IconBillRecharge";
import IconBroadband from "../../assets/images/IconBroadband";
import IconDTH from "../../assets/images/IconDTH";
import IconExploreMore from "../../assets/images/IconExploreMore";
import IconMobileRecharge from "../../assets/images/IconMobileRecharge";
import IconSendmoney from "../../assets/images/IconSendmoney";
import IconCredit from '../../assets/images/IconCredit';
import IconWater from "../../assets/images/IconWater";
import IconAadhayPay from "../../assets/images/IconAadhayPay";

const iconMap = {
  IconAEPS: <IconAEPS />,
  IconAadhayPay: <IconAadhayPay />,
  IconMobileRecharge: <IconMobileRecharge />,
  IconBillRecharge: <IconBillRecharge />,
  IconBroadband: <IconBroadband />,
  IconDTH: <IconDTH />,
  IconSendmoney: <IconSendmoney />,
  IconAddmoney: <IconAddmoney />,
  IconCreditCard: <IconCredit />,
  IconWater: <IconWater />,
  IconExploreMore: <IconExploreMore />
}

const TabNavItem = ({ id, title, isActive, setActiveTab, icon = "" }) => {
 
 
return (
   <div onClick={() =>setActiveTab(id)} className={isActive ? "nav-link active" : "nav-link"}>
    <div className="pic">
		{iconMap?.[icon]}
	</div>
		<span>{title}</span>
   </div>
 );
};
export default TabNavItem;